export default __webpack_public_path__ + "static/media/shanchu.5e359710.png";